import { render, staticRenderFns } from "./AppVersionManagement.vue?vue&type=template&id=bd8626b6&scoped=true&"
import script from "./AppVersionManagement.vue?vue&type=script&lang=js&"
export * from "./AppVersionManagement.vue?vue&type=script&lang=js&"
import style0 from "./AppVersionManagement.vue?vue&type=style&index=0&id=bd8626b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8626b6",
  null
  
)

export default component.exports